import state from '@/vuex-store/hub-adjustment/main/state';
import mutations from '@/vuex-store/hub-adjustment/main/mutations';
import getters from '@/vuex-store/hub-adjustment/main/getters';
import actions from '@/vuex-store/hub-adjustment/main/actions';
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
